import { render, staticRenderFns } from "./MenuHaut.vue?vue&type=template&id=6271667c&scoped=true&"
import script from "./MenuHaut.vue?vue&type=script&lang=js&"
export * from "./MenuHaut.vue?vue&type=script&lang=js&"
import style0 from "./MenuHaut.vue?vue&type=style&index=0&id=6271667c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271667c",
  null
  
)

export default component.exports